import axios from "axios"
import loginService from "./loginService"
import { BASE_SERVER_URL } from "../constants"

/**
 *  TODO: comment out this once we have news paging
 * @param {ObjectId} id 
 * @returns Promise
 */
const getNews = (id) => {
    const URL = `${BASE_SERVER_URL}/news/${id}`
    return axios.get(URL)
        .then(ret => {
            return ret.data
        }).catch(err => err)
}

/**
 * 
 * see news.js
 */
const postNews = (summary, article) => {
    const URL = `${BASE_SERVER_URL}/news`
    const news = { summary, article }
    return loginService.getCredentials()
        .then(creds => {
            const config = {
                headers: {
                    Authorization: creds.accessToken
                }
            }
            return axios.post(URL, news, config)
                .then(ret => {
                    return ret
                }).catch(err => err)
        })
}

const updateNews = (newsId, summary, article) => {
    const URL = `${BASE_SERVER_URL}/news/${newsId}`
    const news = {summary, article}

    return loginService.getCredentials()
        .then(creds => {
            const config = {
                headers: {
                    Authorization: creds.accessToken
                }
            }
            return axios.put(URL, news, config)
                .then(ret => ret).catch(err => err)
        })
}

const deleteNews = (id) => {
    const URL = `${BASE_SERVER_URL}/news/${id}`
    return loginService.getCredentials()
        .then(creds => {
            const config = {
                headers: {
                    Authorization: creds.accessToken
                }
            }
            return axios.delete(URL, config)
                .then(ret => {
                    return ret
                }).catch(err => err.response)
        }).catch(err => err.response)
}

const getAllNews = () => {
    const URL = `${BASE_SERVER_URL}/news`
    return axios.get(URL)
        .then(ret => {
            return ret.data
        }).catch(err => err)

}



export default { postNews, updateNews, deleteNews, getAllNews, getNews }